import styled from "styled-components";

interface Props {
    status: "running" | "finished" | "error" | 'waiting' | 'aborted';
    style?: React.CSSProperties;
}

const Container = styled.div`
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    display: inline-block;
    background-color: dodgerblue;
    margin: .5rem 0;
    position: absolute;
    right: 0;

    &.status-error {
        background-color: #ff0000;
    }
    
    &.status-aborted {
        background-color: transparent;
        color: #7f8c8d;
        font-size: 1.5rem;
    }

    &.status-running {
        //background-color: #ffcc00;
        
        background-color: transparent;
        width: 16px;
        height: 16px;
        border:4px solid #fff;
        border-color: #ffcc00;
        border-right-color:transparent;
        border-top-color:transparent;
        animation: spin 1s linear infinite;

        &:after {
            animation: spin 2s linear infinite;
            display:block;
            width: 60%;
            height: 60%;
            margin: 1px;
            border: 2px solid #ffcc00;
            content:" ";
            border-radius:50%;
            border-left-color:transparent;
            border-bottom-color:transparent;
        }
    }

    &.status-finished {
        background-color: #00ff00;
    }
    
    @keyframes spin {
        from { transform:rotate(0deg); }
        50% { transform:rotate(180deg); }
        to { transform:rotate(360deg); }
    }
    
`;

export default function Status({status, style}: Props) {
    let statusClass = '';
    switch (status) {
        case 'running':
            statusClass = 'status-running';
            break;
        case 'finished':
            statusClass = 'status-finished';
            break;
        case 'error':
            statusClass = 'status-error';
            break;
        case 'aborted':
            statusClass = 'status-aborted';
            break;
        case 'waiting':
            statusClass = 'status-waiting';
            break;
    }

    return (
        <Container className={`status ${statusClass}`} style={style}>
            {status === 'aborted' && (<i className="fa-solid fa-stop"></i>)}
        </Container>
    );
}
